import { Steps } from 'antd';
import styles from './Stepper.module.scss';
import { useStepper } from 'LearningManager/hooks/Stepper.context';
import classNames from 'classnames';

const { Step } = Steps;

const Stepper: React.FC = () => {
	const { current, steps, setupType } = useStepper();

	return (
		<div className={styles.root}>
			<div
				className={classNames(styles.stepper, {
					[styles['stepper--custom']]: setupType === 'Custom Setup'
				})}
			>
				<Steps initial={0} current={current} labelPlacement="vertical">
					{steps.map((item) => (
						<Step key={item.title} title={item.title} />
					))}
				</Steps>
			</div>
		</div>
	);
};

export default Stepper;
